import PrintIcon from "@mui/icons-material/Print";
import MenuItem from "@mui/material/MenuItem";
import type {MenuItemProps} from "@mui/material/MenuItem";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useServerTableContext} from "../ServerTableContext";
import {
    useServerTableToolbarContext,
    useServerTableToolbarItemContext
} from "../ServerTableToolbarContext";
import {defineServerTableToolbarItem} from "../ServerTableToolbarItem";
import type {ServerTablePrintProps} from "../types";
import {ServerTablePrintButton} from "./ServerTablePrintButton";
import {ServerTablePrintDialog} from "./ServerTablePrintDialog";

export const ServerTablePrint = ({
    title,
    selectedDate,
    initialOrientation,
    disabled,
    ...menuItemProps
}: ServerTablePrintProps & Omit<Partial<MenuItemProps>, "id">) => {
    const {t} = useTranslation();
    const {table, query, printRows} = useServerTableContext();
    const {closePanel} = useServerTableToolbarContext();
    const toolbarItem = useServerTableToolbarItemContext();
    const [open, setOpen] = useState(false);
    const isDisabled = disabled || query.isLoading || query.isError || query.isPreviousData;

    if (toolbarItem.presentation === 'menu') {
        return (
            <>
                <MenuItem
                    {...menuItemProps}
                    disabled={isDisabled}
                    onClick={() => {
                        closePanel();
                        toolbarItem.closeMenu();
                        setOpen(true);
                    }}
                >
                    <PrintIcon fontSize="small" sx={{mr: 1, color: 'primary.main'}}/>
                    {t('Print')}
                </MenuItem>

                <ServerTablePrintDialog
                    open={open}
                    onClose={() => setOpen(false)}
                    table={table}
                    title={title}
                    selectedDate={selectedDate}
                    initialOrientation={initialOrientation}
                    printRows={printRows}
                />
            </>
        );
    }

    return (
        <ServerTablePrintButton
            table={table}
            title={title}
            selectedDate={selectedDate}
            initialOrientation={initialOrientation}
            disabled={isDisabled}
            onBeforeOpen={closePanel}
            printRows={printRows}
        />
    );
};

defineServerTableToolbarItem(ServerTablePrint);
